import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, TextField } from '@mui/material';
import { useRef } from 'react';
import { DashboardEmojiPicker } from './DashboardEmojiPicker';

interface EditDashboardEmojiProps {
  dashboardEmoji: string;
  setDashboardEmoji: (emoji: string) => void;
  dialogRef: HTMLDivElement | null;
}

export const EditDashboardEmoji = ({
  dashboardEmoji,
  setDashboardEmoji,
  dialogRef,
}: EditDashboardEmojiProps) => {
  const emojiPickerRef = useRef<HTMLDivElement | null>(null);
  const emojiPickerIDRef = useRef<string>();

  const { openModal, closeModal } = useMuiModalContext();

  const onEmojiClick = (emoji: string) => {
    setDashboardEmoji(emoji);
    closeModal(emojiPickerIDRef.current);
    emojiPickerIDRef.current = undefined;
  };

  const openEmojiPicker = () => {
    emojiPickerIDRef.current = openModal({
      contentComponent: () => (
        <DashboardEmojiPicker onEmojiClick={onEmojiClick} />
      ),
      modalProps: {
        hideBackdrop: true,
        PaperProps: {
          elevation: 0,
          sx: {
            position: 'fixed',
            margin: 0,
            top:
              emojiPickerRef.current && dialogRef?.parentElement
                ? dialogRef.parentElement.offsetTop +
                  emojiPickerRef.current.offsetTop +
                  emojiPickerRef.current.offsetHeight
                : undefined,
            left:
              emojiPickerRef.current && dialogRef?.parentElement
                ? dialogRef.parentElement.offsetLeft +
                  emojiPickerRef.current.offsetLeft
                : undefined,
          },
        },
      },
    });
  };

  return (
    <Box
      sx={{
        width: '80px',
      }}
    >
      <TextField
        label="Icon"
        value={dashboardEmoji}
        onClick={openEmojiPicker}
        ref={emojiPickerRef}
        InputProps={{
          readOnly: true,
          endAdornment: <ArrowDropDownIcon fontSize="small" />,
        }}
      />
    </Box>
  );
};
